import { useState } from "react";
import SectionHeader from "./SectionHeader";
import StoryCard from "@/components/feature/StoryCard";
import { latestStories } from "@/lib/content";

const STEP = 6;

export default function LatestFeed() {
  const all = latestStories();
  const [visible, setVisible] = useState(STEP);
  const shown = all.slice(0, visible);
  const hasMore = visible < all.length;

  return (
    <section className="bg-background-100/70">
      <div id="latest" className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeader
          eyebrow="新瓜速递"
          title="最新爆料 · 滚动直击"
          desc="按发布时间排序，第一时间跟进校园里正在发生的恋爱、表白与纠纷现场。"
        />
        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5 lg:grid-cols-3">
          {shown.map((s) => (
            <StoryCard key={s.slug} story={s} />
          ))}
        </div>
        {hasMore && (
          <div className="mt-9 flex justify-center">
            <button
              type="button"
              onClick={() => setVisible((v) => v + STEP)}
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-add-line text-base" aria-hidden="true" />
              加载更多新瓜
            </button>
          </div>
        )}
      </div>
    </section>
  );
}